import { Snackbar as MuiSnackbar } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

const StyledMuiSnackbar = styled(MuiSnackbar, {
  shouldForwardProp: (prop) => prop !== "$variant",
})(({ theme, $variant }) => ({
  "& .MuiSnackbarContent-root": {
    borderRadius: 4,
    background:
      $variant === "success"
        ? theme.palette_custom.impact
        : $variant === "error"
        ? theme.palette_custom.oos
        : theme.palette_custom.darkBlue,
    color:
      $variant === "success"
        ? theme.palette_custom.darkBlue
        : $variant === "error"
        ? theme.palette_custom.darkBlue
        : theme.palette_custom.darkBlue,
    fontSize: theme.fontSize.sm,
    fontWeight: theme.fontWeight[500],
  },
  "& .MuiSnackbarContent-message": {
    width: "100%",
  },
  "& .MuiSnackbar-root": {
    background:
      $variant === "success"
        ? theme.palette_custom.impact
        : $variant === "error"
        ? theme.palette_custom.oos
        : theme.palette_custom.darkBlue,
  },
  "& .MuiPaper-root": {
    background:
      $variant === "success"
        ? theme.palette_custom.impact
        : $variant === "error"
        ? theme.palette_custom.oos
        : theme.palette_custom.white,
  },
}));

const Snackbar = ({ open, messageLeft, messageRight, onClose, variant }) => {
  return (
    <StyledMuiSnackbar
      $variant={variant}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={open}
      autoHideDuration={10000}
      onClose={onClose}
      message={
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid>{messageLeft}</Grid>
          <Grid>{messageRight}</Grid>
        </Grid>
      }
    />
  );
};

export default Snackbar;
